<div id="question-bank" class="inner-page">

  <div class="container-fluid px-lg-5">

    <div class="page-header">

      <h2 class="title">
        <i class="fa fa-book"></i>
        Question Bank
      </h2>

      <p class="inner-lead">
        Previous year university examination papers are available
        stream-wise and semester-wise to help students prepare effectively.
      </p>

    </div>

    <div class="search-box">
      <i class="fa fa-search"></i>
      <input type="text" placeholder="Search Question Paper">
    </div>

    <div class="session-card">

      <h3>
        <i class="fa fa-folder-open"></i>
        Session 2025-26
      </h3>

      <!-- 2025-26 Odd Semester -->

      <div class="semester-card">

        <div class="semester-header" (click)="toggleOdd2025_26()">

          <h4>Odd Semester</h4>

          <i class="fa" [ngClass]="oddOpen2025_26 ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>

        </div>

        <div class="semester-content" *ngIf="oddOpen2025_26">

          <div class="stream" *ngFor="let stream of oddStreams2025_26">

            <div class="stream-title" (click)="toggleStream(stream)">

              {{stream.name}}

              <i class="fa float-end" [ngClass]="stream.open ? 'fa-minus':'fa-plus'"></i>

            </div>

            <div class="paper-list" *ngIf="stream.open">

              <a *ngFor="let paper of stream.papers" [href]="paper.url" target="_blank" class="paper">

                <i class="fa fa-file-pdf-o"></i>

                <span>{{ paper.title }}</span>

              </a>

              <div *ngIf="stream.papers.length == 0" class="paper">
                No Question Papers Available
              </div>

            </div>

          </div>

        </div>

      </div>

      <!-- 2025-26 Even Semester -->

      <div class="semester-card">

        <div class="semester-header" (click)="toggleEven2025_26()">

          <h4>Even Semester</h4>

          <i class="fa" [ngClass]="evenOpen2025_26 ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>

        </div>

        <div class="semester-content" *ngIf="evenOpen2025_26">

          <div class="stream" *ngFor="let stream of evenStreams2025_26">

            <div class="stream-title" (click)="toggleStream(stream)">

              {{stream.name}}

              <i class="fa float-end" [ngClass]="stream.open ? 'fa-minus':'fa-plus'"></i>

            </div>

            <div class="paper-list" *ngIf="stream.open">

              <a *ngFor="let paper of stream.papers" [href]="paper.url" target="_blank" class="paper">

                <i class="fa fa-file-pdf-o"></i>

                <span>{{ paper.title }}</span>

              </a>

              <div *ngIf="stream.papers.length == 0" class="paper">
                No Question Papers Available
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

    <div class="session-card">

      <h3>
        <i class="fa fa-folder-open"></i>
        Session 2024-25
      </h3>

      <!-- Even Semester -->

      <div class="semester-card">

        <div class="semester-header" (click)="toggleEven()">

          <h4>Even Semester</h4>

          <i class="fa" [ngClass]="evenOpen ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>

        </div>

        <div class="semester-content" *ngIf="evenOpen">

          <div class="stream" *ngFor="let stream of evenStreams">

            <div class="stream-title" (click)="toggleStream(stream)">

              {{stream.name}}

              <i class="fa float-end" [ngClass]="stream.open ? 'fa-minus':'fa-plus'"></i>

            </div>

            <div class="paper-list" *ngIf="stream.open">

              <a *ngFor="let paper of stream.papers" [href]="paper.url" target="_blank" class="paper">

                <i class="fa fa-file-pdf-o"></i>

                <span>{{ paper.title }}</span>

              </a>

              <div *ngIf="stream.papers.length == 0" class="paper">
                No Question Papers Available
              </div>

            </div>

          </div>

        </div>

      </div>

      <!-- Odd Semester -->

      <div class="semester-card">

        <div class="semester-header" (click)="toggleOdd()">

          <h4>Odd Semester</h4>

          <i class="fa" [ngClass]="oddOpen ? 'fa-chevron-up' : 'fa-chevron-down'">
          </i>

        </div>

        <div class="semester-content" *ngIf="oddOpen">

          <div class="stream" *ngFor="let stream of oddStreams">

            <div class="stream-title" (click)="toggleStream(stream)">

              {{stream.name}}

              <i class="fa float-end" [ngClass]="stream.open ? 'fa-minus':'fa-plus'"></i>

            </div>

            <div class="paper-list" *ngIf="stream.open">

              <a *ngFor="let paper of stream.papers" [href]="paper.url" target="_blank" class="paper">

                <i class="fa fa-file-pdf-o"></i>

                <span>{{ paper.title }}</span>

              </a>

              <div *ngIf="stream.papers.length == 0" class="paper">

                No Question Papers Available

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>